module.exports = __webpack_public_path__ + "img/clients-01.a7153485.svg";